'use client';
import { ContextType, useRef } from 'react';
import { useOddsTableMarsContext } from '../../context'
import 'react-horizontal-scrolling-menu/dist/styles.css';
import dynamic from 'next/dynamic';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';
import { useTranslations } from 'next-intl';
import { GameType } from '@nf/types/odds';

type scrollVisibilityApiType = ContextType<typeof VisibilityContext>;
const ScrollMenu = dynamic(() => import('react-horizontal-scrolling-menu').then(mod => mod.ScrollMenu), { ssr: false });

export const GameTypeSwitch = () => {
	const gameTypeMap = new Map<GameType, string>([['FX', 'menu_FIXED'], ['FC', 'menu_FANCY']]);
	const { gameType: currentGameType, updateGameType, sport, isMyFav } = useOddsTableMarsContext();
	const apiRef = useRef({} as scrollVisibilityApiType);
	const t = useTranslations('General');
	if (!isMyFav || sport !== 50) return null;
	return (
		<div className="sports-submenu container" data-open={true}>
			<ScrollMenu
				apiRef={apiRef}
			>
				{
					[...gameTypeMap.entries()].map(([gameType, label]) => {
						return (
							<div
								key={gameType}
								className={'sports-submenu__item'}
								data-selected={gameType === (currentGameType ?? 'FX')}
								onClick={() => updateGameType(gameType)}
							> 
								{t(label)}
							</div>
						)
					})
				}
			</ScrollMenu>
		</div>
	)
}